// src/components/chat/TypingIndicator.tsx
import React from 'react';
import styled from 'styled-components';

const TypingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 1rem;
  background: #f1f1f1;
  border-radius: 1rem;
  width: fit-content;
`;

const Dot = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  background: #666;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out;
  animation-fill-mode: both;

  &:nth-child(1) { animation-delay: -0.32s; }
  &:nth-child(2) { animation-delay: -0.16s; }

  @keyframes bounce {
    0%, 80%, 100% { transform: scale(0); }
    40% { transform: scale(1); }
  }
`;

export const TypingIndicator: React.FC = () => (
  <TypingContainer>
    <Dot />
    <Dot />
    <Dot />
  </TypingContainer>
);
